export const updateBookingEndpoint = '/berths/booking' as const
